'use client'

import {Dialog as DialogPrimitive} from '@base-ui/react/dialog'

import {cn} from '@utilities/helpers'
import {ModalCloseButton} from './modal-atoms'

function Dialog({...props}: DialogPrimitive.Root.Props) {
    return <DialogPrimitive.Root data-slot="dialog" {...props} />
}

function DialogTrigger({...props}: DialogPrimitive.Trigger.Props) {
    return <DialogPrimitive.Trigger data-slot="dialog-trigger" {...props} />
}

function DialogPortal({...props}: DialogPrimitive.Portal.Props) {
    return <DialogPrimitive.Portal data-slot="dialog-portal" {...props} />
}

function DialogClose({...props}: DialogPrimitive.Close.Props) {
    return <DialogPrimitive.Close data-slot="dialog-close" {...props} />
}

function DialogOverlay({className, forceRender, ...props}: DialogPrimitive.Backdrop.Props) {
    return (
        <DialogPrimitive.Backdrop
            className={cn(
                'fixed inset-0 bg-neutral-600/60 transition-opacity duration-500 ease-in-out data-ending-style:opacity-0 data-starting-style:opacity-0',
                !forceRender && 'z-modal-overlay',
                className
            )}
            forceRender={forceRender}
            data-slot="dialog-overlay"
            {...props}
        />
    )
}

function DialogContent({
    className,
    overlayClassName,
    children,
    showCloseButton = true,
    forceRenderOverlay = false,
    ...props
}: DialogPrimitive.Popup.Props & {
    showCloseButton?: boolean
    overlayClassName?: string
    forceRenderOverlay?: boolean
}) {
    return (
        <DialogPortal>
            <DialogOverlay
                className={cn(
                    // This is to ensure the overlay is always on top of the dialog
                    forceRenderOverlay ? 'z-[calc(var(--z-index-modal)+1)]' : 'z-modal-overlay',
                    overlayClassName
                )}
                forceRender={forceRenderOverlay}
            />
            <DialogPrimitive.Popup
                className={cn(
                    'fixed top-1/2 left-1/2 max-h-[calc(100%-(--spacing(6)))] max-w-[calc(100%-(--spacing(6)))] -translate-x-1/2 -translate-y-1/2 overflow-y-auto rounded-xl bg-white shadow-lg outline-none',
                    forceRenderOverlay ? 'z-[calc(var(--z-index-modal)+2)]' : 'z-modal',
                    className
                )}
                data-slot="dialog-content"
                {...props}
            >
                {children}
                {showCloseButton && (
                    <DialogPrimitive.Close
                        data-slot="dialog-close"
                        render={<ModalCloseButton className="absolute left-2 top-2" />}
                    />
                )}
            </DialogPrimitive.Popup>
        </DialogPortal>
    )
}

export {Dialog, DialogClose, DialogContent, DialogOverlay, DialogPortal, DialogTrigger}
